type CodeFormat = 'alphabet' | 'numeric' | 'alphanumeric' | 'hexanumeric';

const ALPHABET_SIZES: Record<CodeFormat, number> = {
  alphabet: 26,
  numeric: 10,
  alphanumeric: 26 + 10,
  hexanumeric: 16
};

export const calculateTotalPermutations = (
  codeFormat: CodeFormat,
  voucherCodeLength: number
): null | number => {
  let alphabetSize = ALPHABET_SIZES[codeFormat];

  if (!alphabetSize || !voucherCodeLength) {
    return null;
  }

  return Math.pow(alphabetSize, voucherCodeLength);
};

export const getRaffleGrandPrizePositionsCount = (raffleGrandPrizes: any[] = []): number =>
  raffleGrandPrizes.reduce((total, prizeSet) => {
    const startRange = Number(prizeSet?.start_range);
    const endRange = Number(prizeSet?.end_range);
    const hasValidRange =
      Number.isFinite(startRange) && Number.isFinite(endRange) && endRange > startRange;

    if (hasValidRange) {
      return total + (endRange - startRange + 1);
    }

    const position = Number(prizeSet?.position);
    const hasValidPosition = Number.isFinite(position) && position >= 0;

    return total + (hasValidPosition ? 1 : 0);
  }, 0);
